module.exports = __webpack_public_path__ + "img/survey-icon.78be68c6.svg";